import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2, type LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export const Hero = ({ children }: { children: ReactNode }) => (
  <div className="bg-gradient-to-r from-primary/10 to-primary/5 rounded-xl p-6 border border-primary/20">
    <p className="text-lg text-muted-foreground">{children}</p>
  </div>
);

export const Section = ({
  icon: Icon,
  title,
  children,
}: {
  icon?: LucideIcon;
  title: string;
  children: ReactNode;
}) => (
  <Card>
    <CardContent className="pt-6">
      <h3 className="text-lg font-semibold mb-3 flex items-center gap-2">
        {Icon && <Icon className="h-5 w-5 text-primary" />}
        {title}
      </h3>
      <div className="space-y-3 text-muted-foreground">{children}</div>
    </CardContent>
  </Card>
);

export const Steps = ({ items }: { items: ReactNode[] }) => (
  <ol className="space-y-3">
    {items.map((s, i) => (
      <li key={i} className="flex gap-3">
        <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-semibold">
          {i + 1}
        </span>
        <div className="pt-1 flex-1">{s}</div>
      </li>
    ))}
  </ol>
);

export const Bullets = ({ items }: { items: ReactNode[] }) => (
  <ul className="space-y-2">
    {items.map((s, i) => (
      <li key={i} className="flex gap-2">
        <CheckCircle2 className="h-4 w-4 text-primary flex-shrink-0 mt-1" />
        <span>{s}</span>
      </li>
    ))}
  </ul>
);

export const Tip = ({ children }: { children: ReactNode }) => (
  <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 text-sm">
    <strong className="text-amber-700 dark:text-amber-400">Tip:</strong>{" "}
    <span className="text-muted-foreground">{children}</span>
  </div>
);
